module.exports = __webpack_public_path__ + "img/SketchPng477c9042038d7decac1a8ee9ee932b2758b9c391fb075013211b297e0dbd266f.c1bb112f.png";